import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./ExitIntentPopup.scss";
import ModalCloseButton from "components/ModalCloseButton";

const ExitIntentPopup = ({ isAuthenticated, setModalSignUpPropsData }) => {
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [hasShownOnce, setHasShownOnce] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Don't show if already shown in this session
    const exitPopupShown = sessionStorage.getItem("exitPopupShown");
    if (exitPopupShown === "true") {
      setHasShownOnce(true);
      return;
    }

    // Detect actual exit attempts (browser close, tab close, navigation away)
    const handleBeforeUnload = (e) => {
      if (!hasShownOnce && isActive) {
        // Show the popup
        setShowExitPopup(true);
        setHasShownOnce(true);
        sessionStorage.setItem("exitPopupShown", "true");

        // Prevent default browser dialog (optional)
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = '';

        // Return false to show popup
        return false;
      }
    };

    // Detect mouse leaving to close tab/browser (backup method)
    const handleMouseOut = (e) => {
      // Only trigger if:
      // 1. Mouse is leaving from top (towards browser controls)
      // 2. Mouse is moving upward (toElement is null or outside document)
      // 3. Not already shown
      // 4. Exit detection is active
      if (
        !hasShownOnce &&
        !showExitPopup &&
        isActive &&
        e.clientY <= 5 &&
        (!e.toElement && !e.relatedTarget)
      ) {
        setShowExitPopup(true);
        setHasShownOnce(true);
        sessionStorage.setItem("exitPopupShown", "true");
      }
    };

    // Activate exit intent after delay
    const activationTimer = setTimeout(() => {
      setIsActive(true);
    }, 3000); // Wait 3 seconds before activation

    // Add event listeners when active
    if (isActive) {
      // Detect actual close/exit attempts
      window.addEventListener("beforeunload", handleBeforeUnload);
      // Backup: detect mouse leaving to close
      document.documentElement.addEventListener("mouseout", handleMouseOut);
      document.documentElement.addEventListener("mouseleave", handleMouseOut);
    }

    return () => {
      clearTimeout(activationTimer);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.documentElement.removeEventListener("mouseout", handleMouseOut);
      document.documentElement.removeEventListener("mouseleave", handleMouseOut);
    };
  }, [hasShownOnce, showExitPopup, isActive]);

  const handleClose = () => {
    setShowExitPopup(false);
  };

  const handleStay = () => {
    setShowExitPopup(false);
  };

  const handleClaim = () => {
    setShowExitPopup(false);
    if (!isAuthenticated && setModalSignUpPropsData) {
      setModalSignUpPropsData(true);
      setTimeout(() => {
        setModalSignUpPropsData(false);
      }, 500);
    }
  };

  return (
    <Modal
      show={showExitPopup}
      onHide={handleClose}
      centered
      className="exit-popup-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="exit-popup-content">
        <ModalCloseButton onClick={handleClose} />

        <img alt="" style={{height: '200px'}} src={require('assets/play365/images/common/exit-image.webp')} />
        <div className="exit-popup-header">
          <h2 className="exit-popup-title">Are you leaving already?</h2>
          <div className="exit-popup-subtitle">
            <p>Don't miss out on your <span className="bonus-highlight">€3000 + 300 FS</span></p>
            <p>Are you sure you want to leave?</p>
          </div>
        </div>

        <div className="exit-popup-background-elements">
          <div className="coin coin-1">🪙</div>
          <div className="coin coin-2">🪙</div>
          <div className="coin coin-3">🪙</div>
          <div className="card card-1">🃏</div>
          <div className="card card-2">🃏</div>
          <div className="dice dice-1">🎲</div>
        </div>

        <div className="exit-popup-actions">
          <button
            className="exit-popup-button-primary"
            onClick={() => {
              handleClose();
              if (!isAuthenticated) {
                setModalSignUpPropsData({ show: true });
              } else {
                window.location.href = '/promotions';
              }
            }}
          >
            Back to Registration
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExitIntentPopup;

